export interface ContactsErrors {
  name?: string;
  email?: string;
  phone?: string;
}

export interface ContactsData {
  name: string;
  email: string;
  phone: string;
}

const EMAIL_REGEX = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

const PHONE_REGEX = /^\+?(?=.*\d)[\d\s\-\(\)]{7,15}$/;

export function validatePhone(phone: string): boolean {
  const trimmed = phone.trim();

  // Must match format and contain at least one digit
  if (!PHONE_REGEX.test(trimmed)) {
    return false;
  }

  // Count only digits for length validation (1-15 digits)
  const digitCount = (trimmed.match(/\d/g) || []).length;
  return digitCount >= 1 && digitCount <= 15;
}

export function validateAppointmentContacts(
  data: ContactsData,
  t: (key: string) => string,
): ContactsErrors {
  const errors: ContactsErrors = {};

  // Name validation
  if (!data.name.trim()) {
    errors.name = t('scheduling.appointment.validation.nameRequired');
  } else if (data.name.trim().length < 2) {
    errors.name = t('scheduling.appointment.validation.nameMinLength');
  }

  // Email validation
  if (!data.email.trim()) {
    errors.email = t('scheduling.appointment.validation.emailRequired');
  } else if (!validateEmail(data.email.trim())) {
    errors.email = t('scheduling.appointment.validation.emailInvalid');
  }

  // Phone validation
  if (!data.phone.trim()) {
    errors.phone = t('scheduling.appointment.validation.phoneRequired');
  } else if (!validatePhone(data.phone.trim())) {
    errors.phone = t('scheduling.appointment.validation.phoneInvalid');
  }

  return errors;
}

export function hasContactsErrors(errors: ContactsErrors): boolean {
  return Object.values(errors).some((error) => !!error);
}
